module.exports = __webpack_public_path__ + "static/media/carlous-img3.5ac90fdf.jpg";